import { Component, OnInit } from '@angular/core';
import { VernostServiceService } from "../../services/vernost-service.service";
import { Router } from "@angular/router";
import { saveAs } from "file-saver";
import * as XLSX from 'ts-xlsx';


@Component({
  selector: 'app-miles-configuration',
  templateUrl: './miles-configuration.component.html'
})
export class MilesConfigurationComponent implements OnInit {
  arrayBuffer: any;
  file: File;
  all_data: Object;
  selectedValue: any;


  ikey = {
    "key": "I"
  }

  dkey = {
    "key": "D"
  }
  loader = false;


  tpm_m_key = [{
    TPM_JOURNEY_TYPE: "TPM_JOURNEY_TYPE",
    TPM_START_RANGE: "TPM_START_RANGE",
    TPM_END_RANGE: "TPM_END RANGE",
    JP_MIN_MILES: "INTERMILES_MIN_MILES",
    JP_MAX_MILES: "INTERMILES_MAX_MILES"
  }]

  constructor(private vernostService: VernostServiceService,
    private router: Router
  ) { }

  ngOnInit() {
    this.selectedValue = "";
  }




  miles_data(value: string) {
    switch (value) {
      case "International":

        this.vernostService.interational_TPM_MILES(this.ikey).subscribe(response => {
          console.log("Search Responce=====", response);
          this.all_data = response[0].result
          //console.log(this.all_data)



        })
        break;

      case "Domestic":
        this.vernostService.domestic_TPM_MILES(this.dkey).subscribe(response => {
          console.log("Search Responce=====", response);
          this.all_data = response[0].result
          //console.log(this.all_data)
        })
        break;
    }
  }





  downloadSample() {

    console.log(this.selectedValue, "<<<<<<<selectedValue");
    switch (this.selectedValue) {
      case "International":
        {
          console.log(this.selectedValue, "<<<<<<<selectedValue");

          this.vernostService.downloadSample_excel_I().subscribe(
            result => {
              saveAs(result, "international.xlsx");
              //alert("ss");
            },
            err => {
              console.log(err);
            }
          );
        }
        break;

      case "Domestic":
        {
          console.log(this.selectedValue, "<<<<<<<selectedValue");

          this.vernostService.downloadSample_excel_d().subscribe(
            result => {
              saveAs(result, "domestic.xlsx");
              //alert("ss");
            },
            err => {
              console.log(err);
            }
          );
        }
        break;
    }
  }





  incomingfile(event) {
    this.file = event.target.files[0];

  }



  Upload() {


    if (this.file) {
      this.loader = false;
      document.getElementById("loder_div").style["display"] = "block";

    } else {
      this.loader = !this.loader;
      document.getElementById("loder_div").style["display"] = "none";

    }

    console.log(this.selectedValue)
    switch (this.selectedValue) {
      case "Domestic":
        {
          let fileRdr = new FileReader();
          fileRdr.onload = (e) => {
            this.arrayBuffer = fileRdr.result;
            var data = new Uint8Array(this.arrayBuffer);
            let array = new Array();
            for (let i = 0; i <= data.length; ++i) {
              array[i] = String.fromCharCode(data[i]);
            }
            var bString = array.join("");
            var workbook = XLSX.read(bString, { type: "binary" });
            var firstSheetName = workbook.SheetNames[0];
            var worksheet = workbook.Sheets[firstSheetName];
            var fileData = XLSX.utils.sheet_to_json(worksheet, { raw: true })
            this.vernostService.Upload_d_miles(fileData).subscribe(
              result => {
                console.log(result);
              },
              err => {
                console.log(err);
              }
            );


          }
          fileRdr.readAsArrayBuffer(this.file);

        }
        break;

      case "International":
        {
          let fileReader = new FileReader();
          fileReader.onload = (e) => {
            this.arrayBuffer = fileReader.result;
            var data = new Uint8Array(this.arrayBuffer);
            var arr = new Array();
            for (var i = 0; i <= data.length; ++i) {
              arr[i] = String.fromCharCode(data[i]);
            }
            var bstr = arr.join("");
            var workbook = XLSX.read(bstr, { type: "binary" });
            var first_sheet_name = workbook.SheetNames[0];
            var worksheet = workbook.Sheets[first_sheet_name];

            var filedata = XLSX.utils.sheet_to_json(worksheet, { raw: true })
            console.log(filedata);

            this.vernostService.Upload_i_miles(filedata).subscribe(
              result => {
                console.log(result);
                //alert("ss");
              },
              err => {
                console.log(err);
              }
            );


          }
          fileReader.readAsArrayBuffer(this.file);

        }


        break;
    }

  }
}
